(function(){
"use strict";
if(new URLSearchParams(location.search).get("kira_editorial")==="0")return;
const $=(s,r=document)=>r.querySelector(s);
const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
const norm=s=>String(s||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/\s+/g," ").trim().toUpperCase();
const options=["hd","holo","clear","hybrid","glow"];
const finishName=s=>{
 const v=norm(s);
 if(!v || v.length>200)return null;
 if(v.includes("HIBRIDO")||v.includes("HYBRID"))return "hybrid";
 if(v.includes("GLOW")||v.includes("BRILLA EN LA OSCURIDAD"))return "glow";
 if(v.includes("TRANSPARENTE")||v.includes("TRANSPARENT"))return "clear";
 if(v.includes("HOLOGRAFICO")||v.includes("HOLOGRAPHIC"))return "holo";
 if(v.includes("FOTOGRAFICO")||v==="HD"||v.startsWith("ACABADO HD"))return "hd";
 return null;
};
function nativeFinish(group){
 if(!group)return null;
 // Campo de Globo seleccionado: no modificar jamás el value.
 for(const input of $$("input[type=radio]:checked,input[type=checkbox]:checked,option:checked",group)){
  const direct=finishName(input.value)||finishName(input.getAttribute("data-value"));
  if(direct)return direct;
  const label=input.id?$$("label",group).find(n=>n.htmlFor===input.id):null;
  const el=label||input.closest("label,.gpo-swatch,[role=radio]")||input.parentElement;
  const key=finishName(el?.textContent);
  if(key)return key;
 }
 for(const node of $$("[aria-checked=true],[aria-selected=true],[data-selected=true],.gpo-selected,.is-selected,.gpo-swatch.selected,.gpo-swatch.active",group)){
  const el=node.closest("label,.gpo-swatch,.gpo-swatch__item,[role=radio]")||node;
  const key=finishName(el.getAttribute("data-value"))||finishName(el.getAttribute("aria-label"))||finishName(el.textContent);
  if(key)return key;
 }
 return null;
}
function clickedFinish(event,group){
 let element=event.target instanceof Element?event.target:null;
 if(!element||!group.contains(element))return null;
 // Ascender solo hasta el control individual, nunca leer todo el carrusel.
 const markers="label,[role=radio],.gpo-swatch__item,.gpo-swatch,.gpo-swatch__inner,button";
 const node=element.closest(markers);
 if(node && group.contains(node)){
  const key=finishName(node.getAttribute("data-value"))||finishName(node.getAttribute("aria-label"))||finishName(node.textContent);
  if(key)return key;
 }
 for(let i=0;element&&i<5&&element!==group;i++,element=element.parentElement){
  if(element.querySelectorAll("img").length>1)break;
  const key=finishName(element.getAttribute("data-value"))||finishName(element.getAttribute("aria-label"))||finishName(element.textContent);
  if(key)return key;
 }
 return null;
}
let installedGuide=null,installedGroup=null;
let keyShown=null;
function showOne(key,fromNative){
 const guide=installedGuide;if(!guide?.isConnected)return;
 const cards=$$(".kp-finish-card",guide);
 if(cards.length!==5)return;
 const index=options.indexOf(key);
 if(index<0)return;
 const next=cards[index];
 if(!next)return;
 const already=keyShown===key && next.classList.contains("kira-v5-picked");
 if(already)return;
 cards.forEach(el=>el.classList.remove("kira-v5-picked"));
 next.classList.add("kira-v5-picked");
 // Reanimar solo el seleccionado (sin recrear CSS del acabado).
 next.classList.remove("kira-v5-enter");
 void next.offsetWidth;
 next.classList.add("kira-v5-enter");
 keyShown=key;
 guide.classList.add("kira-v5-single");
 guide.classList.toggle("kira-v5-unconfirmed",!fromNative);
 const h=$(".kp-title",guide),sub=$(".kp-sub",guide),cue=$(".kp-cue",guide);
 if(h)h.textContent="Así se ve tu acabado";
 if(sub)sub.textContent=fromNative?
  "Ejemplo del efecto en un diseño de muestra. Tu funda llevará el diseño que elegiste.":
  "Ejemplo visual con un diseño de muestra. Elige un acabado arriba.";
 if(cue)cue.textContent="El acabado y cualquier recargo se confirman en el selector.";
}
function stopPreviousGuide(){
 if(installedGroup?.__kiraV5Listener){
  installedGroup.removeEventListener("click",installedGroup.__kiraV5Listener);
  installedGroup.removeEventListener("change",installedGroup.__kiraV5Change);
 }
 installedGuide=null;installedGroup=null;keyShown=null;
}
function initGuide(){
 const guide=$(".kira-v4-finish-guide");
 if(!guide)return false;
 const cards=$$(".kp-finish-card",guide);
 if(cards.length!==5)return false;
 // El V4 ya colocó la guía inmediatamente después del grupo real de acabado.
 const group=guide.previousElementSibling;
 const info=$(".product-information");
 if(!info||!group||!info.contains(group)||!$(".kira-tipo-funda",info)||
   !group.querySelector("img")||group.querySelector(".kira-tipo-funda"))return false;
 if(guide===installedGuide && group===installedGroup)return true;
 stopPreviousGuide();
 installedGuide=guide;installedGroup=group;
 const first=nativeFinish(group);
 // Respaldo seguro: primera referencia ilustrativa sin afirmar que está elegida.
 showOne(first||"hd",!!first);
 const click=e=>{
  const picked=clickedFinish(e,group);
  if(!picked)return;
  setTimeout(()=>{
   const actual=nativeFinish(group);
   showOne(actual||picked,!!actual||!!picked);
  },120);
 };
 const change=()=>setTimeout(()=>{
  const key=nativeFinish(group);
  if(key)showOne(key,true);
 },75);
 group.__kiraV5Listener=click;group.__kiraV5Change=change;
 group.addEventListener("click",click);
 group.addEventListener("change",change);
 group.addEventListener("input",change);
 // En el carrusel se actualizan clases de selección sin disparar change.
 const observer=new MutationObserver(()=>{
  if(!guide.isConnected || !group.isConnected){observer.disconnect();return;}
  const key=nativeFinish(group);
  if(key&&key!==keyShown)showOne(key,true);
 });
 observer.observe(group,{subtree:true,attributes:true,attributeFilter:["class","aria-checked","aria-selected","data-selected","checked"]});
 return true;
}
/* Menú de modelos: las reglas anteriores no alcanzaban la fila seleccionada.
   Agregar sólo una clase de presentación, sin disparar cambios en Globo. */
const modelCandidateSelector="li,[role=option],.gpo-select-option,.gpo-select__option,.gpo-dropdown-option,.gpo-dropdown__option,.gpo-select-item,.gpo-dropdown-item";
function styleModelSelection(){
 const info=$(".product-information");if(!info)return;
 const modelGroups=$$(".gpo-element,.gpo-form__group,[data-element-id],[data-option-id]",info);
 for(const group of modelGroups){
  if(group.closest(".kira-tipo-funda,.kira-marcas,.kira-v4-finish-guide,.kira-case-context"))continue;
  const modelLabel=$(".kira-v3-model-label",group);
  if(!modelLabel)continue; // Nunca pintar opciones de otra parte del carrito.
  const rows=$$(modelCandidateSelector,group);
  if(!rows.length)continue;
  for(const row of rows){
   if(row.closest(".kira-marcas"))continue;
   const selected= row.matches("[aria-selected=true],[aria-checked=true],[data-selected=true],.selected,.active,.is-selected,.gpo-selected")
    ||!!row.querySelector("input:checked");
   row.classList.toggle("kira-v5-model-current",selected);
  }
 }
}
let scheduled=false;
function refresh(){
 if(scheduled)return;scheduled=true;
 requestAnimationFrame(()=>{
  scheduled=false;
  try{initGuide();styleModelSelection();}
  catch(e){console.warn("[KIRA V5] Sólo se preserva Globo original",e);}
 });
}
function start(){
 refresh();
 document.addEventListener("gpoRenderCompleted",refresh);
 document.addEventListener("change",refresh);
 document.addEventListener("click",refresh,{passive:true});
 const observer=new MutationObserver(refresh);
 observer.observe(document.body,{childList:true,subtree:true});
 setTimeout(()=>observer.disconnect(),18000);
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start,{once:true});
else start();
})();